const EMPTY_DATE_LABEL = '—';

const parseDate = (value) => {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const NAIVE_UTC_INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;

const parseInstant = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value);
  const date = new Date(NAIVE_UTC_INSTANT.test(raw) ? `${raw}Z` : raw);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatUtcDate = (value) => {
  const date = parseDate(value);
  if (!date) {
    return EMPTY_DATE_LABEL;
  }

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

export const formatUtcDateTime = (value) => {
  const date = parseInstant(value);
  if (!date) {
    return EMPTY_DATE_LABEL;
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const formatCalendarDate = (value) => {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return EMPTY_DATE_LABEL;
  }
  return `${match[3]}/${match[2]}/${match[1]}`;
};

export const parseCalendarDateKey = (dateKey) => {
  const match = String(dateKey || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return null;
  }

  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(date.getTime()) ? null : date;
};

export const toCalendarDateKey = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getBookingSlotOneHourAhead = (now = new Date()) => {
  const target = new Date(now.getTime() + (60 * 60 * 1000));
  const hours = String(target.getHours()).padStart(2, '0');
  const minutes = String(target.getMinutes()).padStart(2, '0');
  return {
    date: toCalendarDateKey(target),
    startTime: `${hours}:${minutes}`,
  };
};

export const formatClockTime = (value) => {
  const match = String(value || '').match(/^(\d{2}):(\d{2})/);
  if (!match) {
    return EMPTY_DATE_LABEL;
  }
  return `${match[1]}:${match[2]}`;
};
